<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline :model="formData" ref="personnelList">
        <el-form-item label="启用状态" prop="status">
          <static-selector
            ref="memberStatus"
            :showAll="true"
            :value.sync="formData.status"
            type="memberStatus"
          />
        </el-form-item>
        <el-form-item label="门店名称" prop="storeId">
          <fuzzy-query
            ref="storeOption"
            :valueId.sync="formData.storeId"
            typeKey="storeName"
            placeholder="请输入门店名称"
            :option="storeOption"
          ></fuzzy-query>
        </el-form-item>
        <el-form-item label="人员搜索">
          <select-input
            ref="selectPerson"
            :searchList="selectPerson"
            @update="(data) => Object.assign(formData, data)"
          ></select-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button icon="el-icon-plus" type="primary" @click="toAdd">添加人员</el-button>
      <el-table :data="tableData" :loading="loading">
        <el-table-column label="人员姓名" prop="memberName" align="center"></el-table-column>
        <el-table-column label="绑定手机号" prop="phone" align="center" width="200">
          <template slot-scope="scope">
            <div :class="scope.row.isRoot?'tag': ''">{{scope.row.phone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" align="center">
          <template slot-scope="scope">{{scope.row.memberStatus.value}}</template>
        </el-table-column>
        <el-table-column label="门店-角色" align="center" width="220">
          <template slot-scope="scope">
            <div v-for="item in scope.row.stores" :key="item.id">
              {{item.name}}-
              <span v-if="item.roleId===5">门店管理员</span>
              <span v-if="item.roleId===1">门店人员</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="cT" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button class="operateBtn" type="text" @click="toViewAudit(scope.row, '2')">编辑</el-button>
            <el-button
              class="operateBtn"
              type="text"
              v-if="scope.row.memberStatus.value=== '启用'"
              @click="changeStatus(scope.row)"
            >停用</el-button>
            <el-button
              class="operateBtn"
              type="text"
              v-if="scope.row.memberStatus.value=== '停用'"
              @click="changeStatus(scope.row)"
            >启用</el-button>
            <el-button
              class="operateBtn"
              v-if="scope.row.isRoot === 0"
              type="text"
              @click="toDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.page"
          :page-size.sync="formData.size"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { param, getBaseUrl } from "@/framework/utils/tools";
export default {
  data() {
    return {
      formData: {
        groupId: "",
        status: "",
        storeId: "",
        name: "",
        phone: "",
        startTime: "",
        endTime: "",
        page: 0,
        size: 20
      },
      total: 0,
      storeOption: [],
      tableData: [],
      loading: false,
      selectPerson: [
        {
          key: "phone",
          name: "人员手机号",
          placeholder: "请输入人员手机号"
        },
        {
          key: "name",
          name: "人员姓名",
          placeholder: "请输入人员姓名"
        }
      ]
    };
  },
  activated() {
    if (Object.keys(this.$route.params).length > 0) {
      const { storeId, storeName } = this.$route.params;
      Object.assign(this.formData, this.$route.params);
      if (storeId && storeName) {
        this.storeOption = [{ code: storeId, name: storeName }];
      }
    }
    this.getPersonList();
  },
  methods: {
    search() {
      this.formData.page = 1;
      this.getPersonList();
    },
    async getPersonList() {
      this.loading = true;
      const {
        ret,
        data: { list, total }
      } = await _api.member.getPersonList(this.formData);
      if (ret && list) {
        Object.assign(this, { tableData: list, total });
      }
      this.loading = false;
    },
    reset() {
      this.$refs["personnelList"].resetFields();
      ["storeOption", "selectPerson", "memberStatus"].forEach(ref => {
        this.$refs[ref].reset();
      });
    },
    handleSizeChange() {
      this.formData.page = 1;
      this.getPersonList();
    },
    handleCurrentChange() {
      this.getPersonList();
    },
    changeStatus(row) {
      var title =
        row.memberStatus.value === "启用"
          ? "停用会导致该人员不可用，确认停用吗？"
          : "启用后该人员将恢复使用，确认启用么？";
      var successTip = row.id === 1 ? "停用成功！" : "启用成功！";
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        if (row.memberStatus.value === "停用") {
          this.open(row.id);
        } else {
          this.close(row.id);
        }
      });
    },
    async open(memberId) {
      const { ret, data } = await _api.member.open({ memberId });
      if (ret && data) {
        this.$message({
          type: "success",
          message: "启用成功"
        });
        this.getPersonList();
      }
    },
    async close(memberId) {
      const { ret, data } = await _api.member.close({ memberId });
      if (ret && data) {
        this.$message({
          type: "success",
          message: "停用成功"
        });
        this.getPersonList();
      }
    },
    toViewAudit(row, type) {
      this.$router.push({
        path: "/personnelManagement/toViewAudit",
        query: {
          id: row.id,
          type: type
        }
      });
    },
    toAdd() {
      this.$router.push("/personnelManagement/add");
    },
    toDelete(row) {
      if(!(row.isRoot === 0 && row.stores.length === 0)){
        this.$alert('请先解绑人员关联的门店再进行删除', '提示', {
          confirmButtonText: '知道了',
          callback: action => {
            return ;
          }
        });
        return ;
      }
      this.$confirm("确认删除人员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.changeDelete(row.id);
      });
    },
    async changeDelete(memberId) {
      const { ret } = await _api.member.changeDelete({
        memberId
      });
      if (ret) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.search();
      }
    }
  }
};
</script>

<style lang="scss" scope>
.tag {
  margin-left: 42px;
  &::after {
    content: "根账号";
    background: red;
    width: 50px;
    border-radius: 25%;
    color: #fff;
  }
}
</style>
